/**
 * List of specific Rolls-Royce dealers' domains
 * who needs to meet compliance on the DDC website
 */
const rollsRoyceDomains = [
  'rollsroycebraman.com'
]

export const isRollsRoyce = () => rollsRoyceDomains.some(domain => location.host.endsWith(domain))
